export default class EnumHelpers {
    /* No instances guard. */
    private constructor() { }

    /* Get all keys from enumeration. */
    public static keys(enumType: object) {
        const members = Object.keys(enumType)
        return members.filter((x) => Number.isNaN(parseInt(x, 10)))
    }

    public static values(enumType: object) {
        const members = Object.keys(enumType)
        return members.filter((x) => !Number.isNaN(parseInt(x, 10)))
    }

    public static toKeyValueArray(enumType: object)  {
        return EnumHelpers.keys(enumType)
            .map((key) => {
                return { key, value: enumType[key] }
            })
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Helpers/EnumHelpers.ts